import { Article, DocsHeader, DocsHeading, Section, SectionHeader } from "../extra/Components";

import { introQuiz } from './Intro'
import { materialQuiz } from './Material';
import { faltetQuiz } from './Faltet';
import { hoppetQuiz } from './Hoppet';
import { skarmQuiz } from './Underskarm';
import { felFunkQuiz } from './Felfunkioner';
import { landningQuiz } from './Landning';
import { affQuiz } from './Aff';
import { Questionary } from "../extra/Quiz";

import {
    faQuestion,
} from "@fortawesome/free-solid-svg-icons";


const StorQuiz = ({ setSection, setArticle }) => (
    <Article name="Storquiz" icon={faQuestion} id="storquiz" setArticle={setArticle} setSection={setSection}>
        <DocsHeader>
            <DocsHeading note="Updaterad: 2022-07-13">Quiz</DocsHeading>
            <p>Det här är en sammanslagning av alla quiz i den här boken. Kan användas för att repetera det
                hela.</p>
        </DocsHeader>

        <Section id="quizet" name="Quizet">
            <SectionHeader>Quiz, alla sammanslagna</SectionHeader>
            <Questionary questions={[...introQuiz, ...materialQuiz, ...faltetQuiz,
            ...hoppetQuiz, ...skarmQuiz, ...felFunkQuiz, ...landningQuiz, ...affQuiz]} />
        </Section>
    </Article>

);

export default StorQuiz;